import {ValueObject} from '@s-ui/domain'

export class NavigationDataRequestValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Array<id: Number, url: String>} deps.items
   * @param {String} deps.nextPageUrl
   * @param {String} deps.prevPageUrl
   * @param {String} deps.searchUrl
   * @param {String} deps.type
   */

  getItems = () => this._items
  getNextPageUrl = () => this._nextPageUrl
  getPrevPageUrl = () => this._prevPageUrl
  getSearchUrl = () => this._searchUrl
  getType = () => this._type
}
